import { render } from "./WechatAuth.vue?vue&type=template&id=2d23c610&scoped=true"
import script from "./WechatAuth.vue?vue&type=script&lang=js"
export * from "./WechatAuth.vue?vue&type=script&lang=js"

import "./WechatAuth.vue?vue&type=style&index=0&id=2d23c610&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d23c610"]])

export default __exports__